import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../utilities/props';
export default function (props, context) {
    function onClick1() {
        props.handleFooterSave(props);
    }
    function onClick2() {
        props.handleFooterCancel(props);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement('div', { 'className': 'new-account-buttons-box' }, props.rights.isSaveButtonVisible ? React.createElement('div', {
        'className': 'lightbox-save-button',
        'onClick': onClick1.bind(this),
        'key': '196'
    }, 'Save') : null, React.createElement('div', {
        'className': 'lightbox-cancel-button',
        'onClick': onClick2.bind(this)
    }, 'Cancel')));
}